import i18next from 'i18next';

export const EVENTS_PATH = '/events/';
export const WEBINARS_PATH = '/webinars/';
export const BLOGS_PATH = '/blogs/';
export const INDUSTRY_HUBS_PATH = '/industry-hubs/';

export const PORTFOLIOS_PATH = {
  get value() {
    return `${i18next.t('mappable-company-routes.our-product-portfolio-url')}/`;
  },
} as const;

export const adminEventsRouteFormat = (slug: string, lief: string) =>
  slug?.endsWith('/') || lief?.startsWith('/')
    ? `${EVENTS_PATH}${slug}${lief}`
    : `${EVENTS_PATH}${slug}/${lief}`;

export const adminEventPageRouteFormat = (
  eventSlug: string,
  pageSlug: string
) => `${EVENTS_PATH}${eventSlug}/${pageSlug}`;

export const adminWebinarPageRouteFormat = (
  eventSlug: string,
  pageSlug: string
) => `${WEBINARS_PATH}${eventSlug}/${pageSlug}`;

export const adminPortfoliosRouteFormat = (slug: string, lief: string) =>
  slug?.endsWith('/') || lief?.startsWith('/')
    ? `${PORTFOLIOS_PATH.value}${slug}${lief}`
    : `${PORTFOLIOS_PATH.value}${slug}/${lief}`;

export const adminBlogsRouteFormat = (slug: string, lief: string) =>
  slug?.endsWith('/') || lief?.startsWith('/')
    ? `${BLOGS_PATH}${slug}${lief}`
    : `${BLOGS_PATH}${slug}/${lief}`;

export const adminIndustryHubsRouteFormat = (slug: string, lief: string) =>
  slug?.endsWith('/') || lief?.startsWith('/')
    ? `${INDUSTRY_HUBS_PATH}${slug}${lief}`
    : `${INDUSTRY_HUBS_PATH}${slug}/${lief}`;
